"use client";

import React, { useState, useCallback } from "react";
import styles from "./Tooltip.module.scss";
import { TooltipProps } from "@components/atoms/Tooltip/Tooltip.type";
import { cn } from "@utils/utils";

export default function Tooltip({
  content,
  children,
  position = "top",
  show: controlledShow,
  className,
  backgroundColor,
  textColor,
  showOnHover = true,
}: TooltipProps) {
  const [uncontrolledShow, setUncontrolledShow] = useState(false);

  const isVisible =
    controlledShow !== undefined ? controlledShow : uncontrolledShow;

  const handleMouseEnter = useCallback(() => {
    if (showOnHover) {
      setUncontrolledShow(true);
    }
  }, [showOnHover]);

  const handleMouseLeave = useCallback(() => {
    if (showOnHover) {
      setUncontrolledShow(false);
    }
  }, [showOnHover]);

  return (
    <div
      className={cn(styles.tooltipWrapper, className)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={
        {
          "--tooltip-bg": backgroundColor,
          "--tooltip-text": textColor,
        } as React.CSSProperties
      }
    >
      {children}
      <div
        className={cn(
          styles.tooltip,
          styles[position],
          isVisible && styles.visible
        )}
        role="tooltip"
      >
        {content}
      </div>
    </div>
  );
}
